import { NOTIFICATION_CONFIG } from "@/modules/Notification/constants/NotificationConstants";
import { UserStatus } from "@/modules/User/models/UserStatus";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { UserTemplateService } from "@/modules/UserTemplate/services/UserTemplateService";
import { UserService } from "@/modules/User/services/UserService";
import {
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { Http } from "@status/codes";
import { UserQuery } from "@/modules/User/models/UserQuery";
import { DependenciesService } from "@/modules/Dependencies/services/DependenciesService";
import { DependencyQuery } from "@/modules/User/models/DependencyQuery";
import { Dependency } from "@/modules/Dependencies/models/Dependency";
import {
  GENERAL_CONSTANTS,
  STRING_TYPE
} from "@/shared/constants/GeneralConstants";
import { AVAILABILITY_CONSTANTS } from "@/modules/Availability/constants/AvailabilityConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  ATTENDEDBY_COLLECTIONS,
  DEFAULT_EXTENDED_RECIPIENTS,
  DEFAULT_RECIPIENTS,
  DEFAULT_USER,
  EDITING_RECIPIENTS,
  RECIPIENTS,
  TASKS_RULES_RECIPIENTS
} from "./constants/RecipientsConstants";
import { RecipientsConfiguration } from "@/modules/Notification/models/MessageRecipients";
import Vuetify from "vuetify";
import Snackbar from "../Snackbar/Snackbar";
import { BasicObject } from "@/shared/constants/BasicObject";
import { DEPENDENCIES_ACCESS } from "@/modules/Dependencies/constants/DependenciesConstants";
import ChipCounter from "../ChipCounter/ChipCounter.vue";
import { DATA_TYPES } from "@/modules/GeneralRules/constants/GeneralRulesConstants";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { DefaultUser } from "@/shared/models/DefaultUser";
import { forEach } from "lodash";
import { USER_STATES } from "@/modules/User/constants/UserConstants";

Vue.use(Vuetify);

@Component({
  name: "MessageRecipients",
  components: {
    ChipCounter,
    DynamicSelect
  }
})
export default class MessageRecipients extends Vue {
  @Prop({ default: "" }) collection!: string;
  @Prop() recipientsTo?: string;
  @Prop({ default: 0 }) reset!: number;
  @Prop({ default: false }) isEditing!: boolean;
  @Prop({ default: 0 }) editingEvent!: number;
  @Prop() recipients!: RecipientsConfiguration;
  @Prop() editingRecipients!: RecipientsConfiguration;
  @Prop({ default: false }) isMappingData!: boolean;
  @Prop() multipleRecipients?: boolean;
  @Inject() dependenciesService!: DependenciesService;
  @Inject() userTemplateService!: UserTemplateService;
  @Inject() userService!: UserService;

  LABELS = AVAILABILITY_CONSTANTS.LABEL;
  LOAD_MORE_OPTIONS = GENERAL_CONSTANTS.TEXTS.LOAD_MORE_OPTIONS;
  USER_LABEL = NOTIFICATION_CONFIG.LABEL.USER;
  DEPENDENCY_LABEL = RECIPIENTS.LABELS.FILTER_BY_DEPENDENCY;
  DEFAULT_RECIPIENTS_LABEL = RECIPIENTS.LABELS.DEFAULT_RECIPIENTS;
  DEPENDENCIES_EMPTY_TEXT = RECIPIENTS.EMPTY.DEPENDENCIES;
  USER_DEP_EMPTY_TEXT = RECIPIENTS.EMPTY.USERS_DEP;

  USER_HINT = NOTIFICATION_CONFIG.HINT.USER;
  USER_TEMP_HINT = NOTIFICATION_CONFIG.HINT.USER_TEMP;
  USER_FILTERS = NOTIFICATION_CONFIG.USER_FILTERS;
  DEFAULT_RECIPIENTS = DEFAULT_RECIPIENTS;
  DEFAULT_EXTENDED_RECIPIENTS = DEFAULT_EXTENDED_RECIPIENTS;
  ATTENDEDBY_COLLECTIONS = ATTENDEDBY_COLLECTIONS;

  requiredField = FORM_VALIDATORS.REQUIRED_FIELD;

  textFieldClass = STYLE_CLASSES.TEXT_FIELD;

  loadingUsers = false;
  dependencyLastReference = "";
  userLastReference = "";
  dependenciesUserLastReference = "";

  defaultUserFormat =
    this.recipientsTo && this.recipientsTo === "tasks"
      ? []
      : [{ id: DEFAULT_USER.param, name: DEFAULT_USER.name }];
  selectedDefaultUsers = this.defaultUserFormat;
  selectedDependencies: Dependency[] = [];
  selectedUsersByDependency: UserStatus[] = [];

  dependencies: Dependency[] = [];
  dependencyUsers: UserStatus[] = [];
  userDefaultModel = [
    {
      id: "",
      name: ""
    }
  ];
  userDependencietModel: UserStatus[] = [];

  dependenciestModel: Dependency[] = [];

  userDefaultSelectConfig: DynamicSelectConfig = {
    multiple: true,
    default: [],
    chips: true,
    notFound: false,
    listAll: this.defaultUsers.map(user => {
      return { id: user.param, name: user.name };
    }),
    filled: false,
    messageLabel: this.DEFAULT_RECIPIENTS_LABEL,
    hideDetails: true
  };

  dependenciesSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: this.DEPENDENCY_LABEL,
    hideDetails: false
  };

  userDependencySelectConfig: DynamicSelectConfig = {
    multiple: true,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: this.USER_LABEL,
    hideDetails: false
  };

  async mounted() {
    await this.getDependencies();
    this.dependenciesSelectConfig.listAll = this.dependencies.map(
      dependency => {
        return {
          id: dependency.id ?? "",
          name: dependency.name,
          state: dependency.state,
          users: dependency.users,
          external: dependency.external
        };
      }
    );
    if (!this.isEditing) {
      await this.updateData();
      this.userDefaultModel = this.selectedDefaultUsers;
    } else this.editRecipients();
  }

  get userDefaultSelectField() {
    return this.userDefaultModel;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  set userDefaultSelectField(value: any) {
    const option = this.userDefaultSelectConfig.listAll.find(
      item => item.id === value
    );
    this.userDefaultModel = [
      {
        id: option?.id ?? "",
        name: option?.name ?? ""
      }
    ];
  }

  get dependencySelectField() {
    const filteredArray = this.dependenciestModel.map(item => item.id);
    return filteredArray.filter(item => item !== null && item !== "");
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  set dependencySelectField(value: any) {
    const option = this.dependenciesSelectConfig.listAll.find(
      item => item.id === value
    );
    if (option != undefined) {
      this.dependenciestModel = [
        {
          id: option?.id ?? "",
          name: option?.name ?? "",
          state: typeof option?.state === "string" ? option.state : "",
          users: typeof option?.users === "object" ? option.users : [],
          external:
            typeof option?.external === "string" ? option.external : false
        }
      ];
    }
  }

  get editDependencySelect() {
    return this.dependenciestModel;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  set editDependencySelect(value: any) {
    const search: any = [];
    forEach(value, elem => {
      const option = this.dependenciesSelectConfig.listAll.find(
        item => item.id === elem
      );
      if (option != undefined) {
        search.push({
          id: option?.id ?? "",
          name: option?.name ?? "",
          state: typeof option?.state === "string" ? option.state : "",
          users: typeof option?.users === "object" ? option.users : [],
          external:
            typeof option?.external === "string" ? option.external : false
        });
      }
    });
    this.dependenciestModel = search;
  }

  get userDependencieSelectField() {
    return this.userDependencietModel;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  set userDependencieSelectField(value: any) {
    const option = this.userDependencySelectConfig.listAll.find(
      item => item.id === value
    );
    if (option != undefined) {
      this.userDependencietModel = [
        {
          id: option?.id ?? "",
          name: option?.name ?? "",
          userName: option?.userName ?? "",
          userState: option?.userState ?? "",
          userEmail: option?.userEmail ?? "",
          userPhone: option?.userPhone ?? ""
        }
      ];
    }
  }

  @Watch("editingEvent")
  async editRecipients() {
    if (this.isEditing) {
      await this.getDependencies();
      this.loadingUsers = true;
      await this.mapNotificationReceiverData();
      this.$emit(RECIPIENTS.EVENTS.MAPPED);
      this.loadingUsers = false;
    }
  }

  @Watch("reset")
  async resetNotification() {
    if (this.isEditing) {
      await this.mapNotificationReceiverData();
    } else {
      this.clearReceiverData();
    }
  }

  async mapNotificationReceiverData() {
    if (
      this.editingRecipients.defaultRecipients &&
      this.editingRecipients.defaultRecipients.length > 0
    ) {
      const list: DefaultUser[] = [];
      const defaultUsers = this.editingRecipients.defaultRecipients.map(
        recipient => {
          const param =
            typeof recipient == DATA_TYPES.STRING
              ? recipient
              : (recipient as BasicObject).param;
          return (
            DEFAULT_EXTENDED_RECIPIENTS.find(data => data.param === param) ?? {}
          );
        }
      );
      defaultUsers.forEach((item: any) => {
        if (item.name) {
          list.push({ id: item.param, name: item.name });
        }
      });
      this.userDefaultModel = list;
      this.selectedDefaultUsers = list;
    } else {
      this.selectedDefaultUsers = [];
    }
    if (
      this.editingRecipients.dependencies &&
      this.editingRecipients.dependencies.length > 0
    ) {
      const dependencyList = this.getIdsArray(
        this.editingRecipients,
        EDITING_RECIPIENTS.DEPENDENCIES
      );
      this.editDependencySelect = dependencyList;
      this.dependenciestModel = this.editDependencySelect;
      await this.getDependenciesByArray(dependencyList);
    } else {
      this.selectedDependencies = [];
    }
    if (
      this.editingRecipients.dependencyUsers &&
      this.editingRecipients.dependencyUsers.length > 0
    ) {
      this.dependenciesUserLastReference = "";
      await this.getDependencyUsers();
      const userList = this.getIdsArray(
        this.editingRecipients,
        EDITING_RECIPIENTS.DEPENDENCY_USERS
      );

      const foundUsers = await this.getUsersByIdArray(userList);

      this.userDependencietModel = foundUsers;
      this.selectedUsersByDependency = foundUsers;
    } else {
      this.selectedUsersByDependency = [];
    }
    this.updateData();
  }

  getIdsArray(recipients: RecipientsConfiguration, key: string): string[] {
    let list: Array<any>;
    switch (key) {
      case EDITING_RECIPIENTS.DEPENDENCY_USERS:
        list = recipients.dependencyUsers;
        break;
      default:
        list = recipients.dependencies;
        break;
    }
    if (list.every(element => typeof element === STRING_TYPE)) {
      return list;
    } else {
      return list.map(element =>
        key === EDITING_RECIPIENTS.USER_TEMPLATES ? element._key : element.id
      );
    }
  }

  async getDependencies() {
    try {
      const query: DependencyQuery = {
        state: ["Activo"],
        paginatedResult: true
      };
      if (this.dependencyLastReference !== "") {
        query.docref = this.dependencyLastReference;
      }

      const dependenciesResponse = await this.dependenciesService.getDependenciesWithFilters(
        query
      );

      if (
        dependenciesResponse.code === Http.Found &&
        dependenciesResponse.data !== undefined
      ) {
        this.dependencies = this.dependencies.concat(
          dependenciesResponse.data.data
        );
        this.dependenciesSelectConfig.listAll = this.dependencies.map(item => {
          return {
            id: item.id ?? "",
            name: item.name,
            state: item.state,
            users: item.users,
            external: item.external
          };
        });

        this.dependencyLastReference = dependenciesResponse.data.docRef;
      } else {
        this.dependencyLastReference = "";
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${DEPENDENCIES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
      return;
    }
  }

  async getUsersByIdArray(userArray: string[]) {
    try {
      if (userArray.length > 0) {
        const userQuery: UserQuery = {
          usersId: userArray
        };

        const usersResponse = await this.userService.getUsersByIdsArray(
          userQuery
        );

        if (
          usersResponse.code === Http.Found &&
          usersResponse.data !== undefined
        ) {
          return usersResponse.data;
        }
      }
      return [];
    } catch (error) {
      return [];
    }
  }

  async getDependenciesByArray(dependencies: string[]) {
    await this.getDependencies();
    const foundDependencies = this.dependencies.filter(
      dependency => dependency.id && dependencies.includes(dependency.id)
    );
    for (const [index, user] of foundDependencies.entries()) {
      Vue.set(this.selectedDependencies, index, user);
    }
  }

  clearReceiverData() {
    this.selectedDefaultUsers = this.defaultUserFormat;
    this.selectedDependencies = [];
    this.selectedUsersByDependency = [];
  }

  recipientsValidation() {
    if (this.multipleRecipients || this.multipleRecipients != undefined) {
      const filterVoidUser = this.userDependencietModel.filter(
        item => item.id !== ""
      );
      const filterVoidDep = this.dependenciestModel.filter(
        item => item.id !== ""
      );

      const filterVoidDefault = this.userDefaultModel.filter(
        item => item.id !== ""
      );

      if (
        filterVoidUser.length > 0 &&
        filterVoidDep.length > 0 &&
        filterVoidDefault.length > 0
      ) {
        this.$emit(RECIPIENTS.EVENTS.UPDATE_MULTIPLE_RECIPIENTS, true);
        return;
      }
      this.$emit(RECIPIENTS.EVENTS.UPDATE_MULTIPLE_RECIPIENTS, false);
    }
  }

  @Watch("userDependencietModel", { deep: true })
  selectedUsersByDependencyUpdate() {
    if (!this.isMappingData) {
      this.selectedUsersByDependency = this.userDependencietModel;
      this.selectedDependencies = this.dependenciestModel.filter(
        item => item.id !== ""
      );
      if (
        this.recipientsTo &&
        this.recipientsTo === "tasks" &&
        this.selectedDependencies.length > 0
      ) {
        this.userDependencySelectConfig.rules = [
          FORM_VALIDATORS.REQUIRED_ARRAY
        ];
      } else {
        delete this.userDependencySelectConfig.rules;
      }

      this.$emit(
        RECIPIENTS.EVENTS.UPDATE_DEPENDENCY_USERS,
        this.selectedUsersByDependency
      );
      this.$emit(
        RECIPIENTS.EVENTS.UPDATE_DEPENDENCIES,
        this.selectedDependencies
      );
    }
    this.recipientsValidation();
  }

  @Watch("dependenciestModel", { deep: true })
  async selectedDependenciesUpdate() {
    if (!this.isMappingData) {
      this.dependencySelectField = this.dependenciestModel;
      if (this.selectedDependencies != this.dependenciestModel) {
        this.userDependencietModel = [];
      }
      this.selectedDependencies = this.dependenciestModel.filter(
        item => item.id !== ""
      );
      this.selectedUsersByDependency = [];
      if (this.selectedDependencies.length > 0) {
        this.selectedDefaultUsers = [];
      } else {
        this.selectedDefaultUsers = this.defaultUserFormat;
      }
      this.$emit(
        RECIPIENTS.EVENTS.UPDATE_DEPENDENCIES,
        this.selectedDependencies
      );
      this.dependenciesUserLastReference = "";
      await this.getDependencyUsers();
    }
    this.recipientsValidation();
  }

  async getDependencyUsers(valueSearch?: string) {
    if (this.selectedDependencies.length == 0) {
      this.dependencyUsers = [];
      this.userDependencySelectConfig.listAll = [];
      return;
    }

    const arrayDependencies = this.selectedDependencies.map(e => e.name);

    const query: UserQuery = {
      dependency: arrayDependencies,
      state: USER_STATES.ACTIVE
    };

    if (this.dependenciesUserLastReference !== "") {
      query.idReference = this.dependenciesUserLastReference;
    }

    if (valueSearch) {
      query.notPaginate = true;
      query.name = [valueSearch];
      delete query.idReference;
    }

    const responseData = await this.userService.getUsersByFiltersArrayUsersCrud(
      query
    );

    if (responseData.code === Http.Found && responseData.data !== undefined) {
      if (this.dependenciesUserLastReference != "") {
        this.dependencyUsers = this.dependencyUsers.concat(
          responseData.data.userArray
        );
      } else {
        this.dependencyUsers = responseData.data.userArray;
      }
      this.userDependencySelectConfig.listAll = this.dependencyUsers.map(
        user => {
          return {
            id: user.id ?? "",
            name:
              user.name && user.name != "" ? user.name : user.userDocument ?? ""
          };
        }
      );
      this.dependenciesUserLastReference = responseData.data.lastReference;
    } else {
      this.userDependencySelectConfig.listAll = [];
    }
  }

  @Watch("userDefaultModel", { deep: true })
  async userDefaultModelUpdate() {
    if (!this.isMappingData) {
      const usersDefault = this.formatUserDefault(this.userDefaultModel);
      this.$emit(RECIPIENTS.EVENTS.UPDATE_DEFAULT, usersDefault);
    }
    this.recipientsValidation();
  }
  get defaultUsers() {
    if (this.recipientsTo == "tasks") {
      return TASKS_RULES_RECIPIENTS;
    }

    const array = ATTENDEDBY_COLLECTIONS.includes(this.collection)
      ? DEFAULT_EXTENDED_RECIPIENTS
      : DEFAULT_RECIPIENTS;
    return array;
  }

  updateData() {
    const usersDefault = this.formatUserDefault(this.selectedDefaultUsers);
    this.$emit(RECIPIENTS.EVENTS.UPDATE_DEFAULT, usersDefault);
    this.$emit(
      RECIPIENTS.EVENTS.UPDATE_DEPENDENCIES,
      this.selectedDependencies
    );
    this.$emit(
      RECIPIENTS.EVENTS.UPDATE_DEPENDENCY_USERS,
      this.selectedUsersByDependency
    );
  }

  formatUserDefault(userDefault: DefaultUser[]) {
    return userDefault.map(user => ({ param: user.id, name: user.name }));
  }
}
